import { useState } from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import { Link, useHistory } from 'react-router-dom'
import { Box, Image } from 'rebass/styled-components'

export default ({ data = [], withLink }) => {
    const [swipping, setSwipping] = useState(false)
    const history = useHistory()
    const handleClick = (index, item) => {
        if (item.props.to && !swipping) {
            history.push(item.props.to)
        }
    }
    return (
        <Box my="20px">
            <Carousel
                renderThumbs={() => null}
                swipeable
                autoPlay
                infiniteLoop
                interval={1800}
                onSwipeStart={() => setSwipping(true)}
                onSwipeEnd={() => setSwipping(false)}
                onClickItem={handleClick}
            >
                {data.map((item, index) => (
                    <Box key={index} to={withLink ? `/category/${item.handle}` : null}>
                        <Image minHeight="200px" src={item.src} />
                    </Box>
                ))}
            </Carousel>
        </Box>
    )
}
